import {ICON_TYPES} from '../constants';

export const LensIcon = (): JSX.Element => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.9734 19.2982L14.7689 14.0937C16.1208 12.4403 16.7855 10.3305 16.6255 8.20076C16.4655 6.071 15.493 4.08422 13.9092 2.65137C12.3254 1.21851 10.2515 0.44922 8.11638 0.502604C5.98129 0.555988 3.94839 1.42797 2.43818 2.93818C0.927967 4.44839 0.0559876 6.48129 0.00260355 8.61638C-0.0507805 10.7515 0.718515 12.8254 2.15137 14.4092C3.58422 15.993 5.571 16.9655 7.70076 17.1255C9.83051 17.2855 11.9403 16.6208 13.5937 15.2689L18.7982 20.4734L19.9734 19.2982ZM8.33775 15.4867C7.02272 15.4867 5.73722 15.0967 4.64381 14.3661C3.5504 13.6355 2.69819 12.5971 2.19495 11.3822C1.69171 10.1673 1.56004 8.83038 1.81659 7.54061C2.07314 6.25085 2.70639 5.06613 3.63626 4.13626C4.56613 3.20639 5.75085 2.57314 7.04061 2.31659C8.33038 2.06004 9.66726 2.19171 10.8822 2.69495C12.0971 3.19819 13.1355 4.0504 13.8661 5.14381C14.5967 6.23722 14.9867 7.52272 14.9867 8.83775C14.9847 10.6006 14.2836 12.2906 13.0371 13.5371C11.7906 14.7836 10.1006 15.4847 8.33775 15.4867Z'
        fill='#141414'
      />
    </svg>
  );
};

LensIcon.iconType = ICON_TYPES.LENS;
